import {
  Client,
  ClientOptions,
} from '@microsoft/microsoft-graph-client';
import { useVariable } from '@softwareimaging/backstage';
import { FC, PropsWithChildren, useMemo } from 'react';
import { useRequestToken } from '../authentication/hooks/auth';
import { Variables } from '../backstage/config';
import { GraphContext } from './useGraphProvider';

export const GraphProvider: FC<PropsWithChildren> = ({ children }) => {
  // If we're using the proxy, we need to set the base URL and custom hosts
  const proxy = useVariable<Variables>('graphBaseUrl');
  if (!proxy) throw new Error('Missing graphBaseUrl');
  const getAccessToken = useRequestToken();

  const client = useMemo(() => {
    const options: ClientOptions = {
      defaultVersion: 'v1.0',
      authProvider: {
        getAccessToken: async () => {
          const { accessToken } = await getAccessToken();
          return accessToken;
        }
      }
    };

    // If we're using the proxy, we need to set the base URL and custom hosts
    const url = new URL(proxy);
    options.baseUrl = url.toString();
    options.customHosts = new Set([url.hostname]);

    // If we're not using the proxy, the URL is already set to the default
    const client = Client.initWithMiddleware(options);
    return client;
  }, [getAccessToken, proxy]);

  return <GraphContext.Provider value={{ client }}>{children}</GraphContext.Provider>;
};
